import { api } from "./api";

const saleslistApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSalesList: builder.query({
      query: () => "orders",
      providesTags: ["orders"],
    }),
    addSales: builder.mutation({
      query: (newCategory) => ({
        url: "orders",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["orders"],
    }),
    removeSaleslist: builder.mutation({
      query: (id) => ({
        url: `orderses?inv_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["orders"],
    }),
  }),
});

export const {
  useGetSalesListQuery,
  useAddSalesMutation,
  useRemoveSaleslistMutation,
} = saleslistApi;